import { createGlobalStyle } from 'styled-components';
import GreatVibes from '../fonts/GreatVibes-Regular.ttf';
import Vazir from '../fonts/Vazir.woff2';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Great Vibes';
    src: url(${GreatVibes}) format('truetype');
  }

  @font-face {
    font-family: 'Vazir';
    src: url(${Vazir}) format('woff2');
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    margin: 0;
    overflow-x: flex;
    font-family: 'Vazir', sans-serif;
    direction: rtl;
  }

  button {
    font-family: inherit;
  }
`;

export default GlobalStyle;
